"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _index = _interopRequireDefault(require("@/componentsBuz/CheckNoticePrice/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "",
  components: {
    checkNoticePrice: _index.default,
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    copyId: {
      type: String,
      default: ''
    },
    pol: {
      type: String,
      default: ''
    },
    copyForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      filterForm: {
        copyId: '',
        bkType: 0,
        copyCount: null
      },
      unableAutoGeneral: false,
      loading: false,
      rules: {
        copyCount: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      var _this = this;
      this.filterForm.copyCount = null;
      (0, _booking.autoGeneralBlNo)(this.pol).then(function (res) {
        if (!res.data.bkNoFlag && !res.data.blNoFlag) {
          _this.unableAutoGeneral = true;
          _this.filterForm.bkType = 1;
        } else {
          _this.unableAutoGeneral = false;
          _this.filterForm.bkType = 0;
        }
      });
      //   this.handleSearch()
      console.log('opened');
    },
    handleCheckSubmit: function handleCheckSubmit() {
      this.type ? this.handleSubmitDataSingle() : this.handleSubmitData();
    },
    // 判断有没有通告
    handleCheck: function () {
      var _handleCheck = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(type) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.type = type;
              data = {
                pol: this.pol,
                singleContainerFlag: type
              };
              _context.next = 4;
              return this.$store.dispatch('isSaveTip/checkQuery', data);
            case 4:
              this.checkDtaParams = _context.sent;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCheck(_x) {
        return _handleCheck.apply(this, arguments);
      }
      return handleCheck;
    }(),
    handleSubimtSign: function handleSubimtSign() {
      var _this2 = this;
      this.$refs.filterForm.validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 5;
                  break;
                }
                _context2.next = 3;
                return _this2.handleCheckPrice(_this2.copyForm, 1);
              case 3:
                console.log(_this2.checkDtaParams, 'this.checkDtaParams');
                if (_this2.checkDtaParams && Object.keys(_this2.checkDtaParams).length) {
                  _this2.$parent.copyVisible = false;
                  _this2.$refs.checkNoticePrice.checkPriceVisible = true;
                } else {
                  _this2.handleSubmitDataSingle();
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 判断有没有通告和运价
    handleCheckPrice: function () {
      var _handleCheckPrice = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(row, type) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.type = type;
              data = {
                pol: row.pol,
                pod: row.pod,
                etd: row.etd,
                serviceLineCode: row.serviceLineCode,
                vesselCode: row.vesselCode,
                voyageNo: row.voyageNo,
                voyageLeg: row.voyageLeg,
                singleContainerFlag: type
              };
              _context3.next = 4;
              return this.$store.dispatch('isSaveTip/checkQueryPrice', data);
            case 4:
              this.checkDtaParams = _context3.sent;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleCheckPrice(_x3, _x4) {
        return _handleCheckPrice.apply(this, arguments);
      }
      return handleCheckPrice;
    }(),
    handleSubmitDataSingle: function handleSubmitDataSingle() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      this.filterForm.copyId = this.copyId;
      this.filterForm.copyCount = this.filterForm.copyCount + '';
      this.filterForm.bkType = this.filterForm.bkType + '';
      (0, _booking.saveOrUpdateByMutiCopySingle)(this.filterForm).then(function (res) {
        if (res.success) {
          _this3.$message({
            message: _this3.$t('home.copySuccess'),
            type: 'success'
          });
          if (_this3.$route.path.indexOf('bookingSpaceMy') !== -1) {
            _this3.$parent.handleSearch();
          }
          _this3.$parent.copyVisible = false;
          _this3.$refs.checkNoticePrice.checkPriceVisible = false;
        }
      }).catch(function () {}).finally(function () {
        _this3.loading.close();
      });
    },
    handleSubimt: function handleSubimt() {
      var _this4 = this;
      this.$refs.filterForm.validate( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(valid) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!valid) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 3;
                return _this4.handleCheck(0);
              case 3:
                console.log(_this4.checkDtaParams, 'this.checkQuery');
                if (_this4.checkDtaParams && Object.keys(_this4.checkDtaParams).length) {
                  if (_this4.$route.path.indexOf('bookingSpaceMy') !== -1) {
                    _this4.$parent.handleSearch();
                  }
                  _this4.$parent.copyVisible = false;
                  _this4.$refs.checkNotice.checkVisible = true;
                } else {
                  _this4.handleSubmitData();
                }
              case 5:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleSubmitData: function handleSubmitData() {
      var _this5 = this;
      this.loading = (0, _utils.load)();
      this.filterForm.copyId = this.copyId;
      this.filterForm.copyCount = this.filterForm.copyCount + '';
      this.filterForm.bkType = this.filterForm.bkType + '';
      (0, _booking.saveOrUpdateByMutiCopy)(this.filterForm).then(function (res) {
        // this.loading.close()
        if (res.success) {
          _this5.$message({
            message: _this5.$t('home.copySuccess'),
            type: 'success'
          });
          if (_this5.$route.path.indexOf('bookingSpaceMy') !== -1) {
            _this5.$parent.handleSearch();
          }
          _this5.$parent.copyVisible = false;
          _this5.$refs.checkNotice.checkVisible = false;
        }
      }).catch(function () {
        // this.loading.close()
      }).finally(function () {
        _this5.loading.close();
      });
    },
    handleSearch: function handleSearch() {
      var _this6 = this;
      (0, _booking.queryListVoyagePlan)(this.filterForm).then(function (res) {
        _this6.tableData = res.data.records;
        _this6.total = res.data.totalRecord;
      });
    }
  }
};